import { LinkItem } from '@occc-app/design-system';
import { SteeringWalletBasis } from '@occc/graphql';
import { pluralize } from '@occc-app/lib/strings';

import { ProductGroupAlertSeverity } from '../types';
import { routeCreator } from '../utils';

export const breadcrumbLinks: LinkItem[] = [
  { to: routeCreator.list(), label: 'Wallets' },
  { key: routeCreator.create(), label: 'Create Wallet' },
];

export const titleByPeriod: Record<SteeringWalletBasis, string> = {
  [SteeringWalletBasis.Daily]: 'day',
  [SteeringWalletBasis.Weekly]: 'week',
  [SteeringWalletBasis.Monthly]: 'month',
};

export const productGroupAlerts: Record<
  ProductGroupAlertSeverity,
  (productCount: number) => string
> = {
  success: (productCount: number) =>
    `This product group contains ${productCount} ${pluralize(
      productCount,
      'product',
    )}. Smaller product groups like this one go a long way in making Wallet's numbers more reliable.`,
  warning: (productCount: number) =>
    `This product group contains ${productCount} ${pluralize(
      productCount,
      'product',
    )}. Using even smaller product groups may help you get better results when creating Wallets.`,
  error: (productCount: number) =>
    `This product group contains ${productCount} ${pluralize(
      productCount,
      'product',
    )}. To make the most out of your Wallet, please consider creating and using smaller product groups.`,
};
